import {
  CouponType,
  OnSiteLocationType,
  OrderMethod,
  PaymentMethod,
  RefundReason,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Informações da encomenda',
  sections: {
    driver_info: 'Info do estafeta',
    order_info: 'Informações da encomenda',
    price_info: 'Informações de preço',
    adjustments: 'Ajustes',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Levantamento',
    [OrderMethod.Delivery]: 'Entrega',
    [OnSiteLocationType.RoomService]: 'Serviço de quarto',
    [OnSiteLocationType.TableService]: 'Serviço de mesa',
  },
  room_service_location_types: {
    [OnSiteLocationType.RoomService]: {
      details_label: 'Número do quarto',
    },
    [OnSiteLocationType.TableService]: {
      details_label: 'Número da mesa',
    },
  },
  labels: {
    wolt_support: 'Número de suporte Wolt: {{phone_number}}',
    wolt_support_text:
      'Se tiver alguma questão sobre a encomenda, o estafeta ou problemas, contacte a Wolt. É importante dizer que é uma encomenda <strong>Wolt Drive</strong>',
    dummy_order: 'Encomenda de teste',
    asap: 'O mais breve possível',
    driver_name: 'Nome do estafeta',
    driver_phone_number: 'Telefone do estafeta',
    pin_code: 'PIN',
    dropoff_pin_code: 'PIN de entrega',
    original: 'Original',
    delivery_fee: 'Taxa de entrega',
    tip: 'Gorjeta',
    service_fee: 'Processamento online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Taxa PayPal',
    },
    promo_applied: {
      default: 'Promoção aplicada',
      [CouponType.Reward]: 'Pontos de fidelidade aplicados',
      [CouponType.Cashback]: 'Pontos de fidelidade aplicados',
      [CouponType.PromoCode]: 'Promoção aplicada',
      [CouponType.GiftCard]: 'Cartão de oferta aplicado',
    },
    tax: 'Impostos',
    total: 'Total',
    online_payment: 'Cliente já pagou na app {{provider}}',
    cash_payment: 'Pagamento no local',
    invoice_payment: 'Pagamento por fatura',
    old_order: 'Esta encomenda foi concluída com sucesso',
    pickup_time: 'Hora de levantamento',
    pickup_asap: 'O cliente pediu o levantamento o mais rapidamente possível.',
    points_used: 'Esta encomenda inclui uma recompensa de pontos de fidelidade resgatada por um cliente fiel',
    order_note: 'Nota da encomenda:',
    today: 'hoje',
  },
  schedule: {
    header: 'Agendada para {{date}}, {{time}}',
    text: 'Iremos avisá-lo quando for hora de começar a preparar a encomenda',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Pedido pelo cliente',
    [RefundReason.Reclamation]: 'Reclamação',
    [RefundReason.CommunicationError]: 'Erro de comunicação',
    [RefundReason.Other]: 'Outro',
    [RefundReason.Dispute]: 'Disputa com cliente',
    dispute_win: 'Disputa com cliente ganha',
    null: '',
  },
  toasts: {
    print_one: 'A imprimir {{count}} recibo: Encomenda <strong>#{{orderNumber}}</strong>...',
    print_other: 'A imprimir {{count}} recibos: Encomenda <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Reembolso bem-sucedido: Encomenda <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Imprimir',
    confirm: 'Confirmar',
    reject: 'Rejeitar',
    refund: 'Reembolso',
  },
};
